/**
 * Deterministic PRNG (mulberry32). All sim randomness flows through one
 * instance per game; nothing else in the sim may roll dice. The algorithm is
 * bit-identical to the prototype's -- replays depend on the exact sequence.
 */
export class Mulberry32 {
  private state: number;

  constructor(seed: number) {
    this.state = seed >>> 0;
  }

  /** Uniform float in [0, 1) -- one 32-bit state advance per call. */
  next(): number {
    this.state = (this.state + 0x6d2b79f5) >>> 0;
    let t = this.state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }
}
